export const bottomNavbarStyles = {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: '#121212',
    borderTop: '1px solid #282828',
};

export const drawerStyles = {
    display: { xs: 'none', md: 'block' },
    '& .MuiDrawer-paper': {
        backgroundColor: '#121212',
        color: 'white',
        width: 240,
    },
};